<template>
  <div class="Service">
    <div class="page-title">{{ title }}</div>
    <el-tabs 
      ref="tabs" 
      v-model="activeTab" 
      type="card"
    >
      <el-tab-pane label="리스트" name="0">
        <ServiceList 
          ref="list"
          :has_grant_write="has_grant_write"
          @selectAddress="handleSelectAddress"
          @requestedForm="handleRequestedForm"
        />
      </el-tab-pane>
      <el-tab-pane label="등록" name="1">
        <ServiceForm 
          ref="form"
          v-if="activeTab === '1'"
          :data="data"
          :has_grant_write="has_grant_write"
          @completed="handleCompletedForm"
          @closed="handleClosedForm"
        />
      </el-tab-pane>
      <el-tab-pane label="이력" name="2">
        <ServiceHistory 
          v-if="activeTab === '2'"
          :address="addr"          
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ServiceList from "./ServiceList";
import ServiceForm from "./ServiceForm";
import ServiceHistory from "./ServiceHistory";
import { authority_level } from "@/common/mixins/authority_level";

export default {
  name: "Service", 
  mixins: [authority_level],
  components: {ServiceList, ServiceForm, ServiceHistory},
  data() {
    return {
      title: this.$t("title.as"),
      activeTab: '0',
      data: undefined,
      addr: '',
    }
  },  
  computed: {          
    has_grant_write() {      
      return this.isWriteLevel('as');
    },
  },
  methods: {
    handleRequestedForm(data) {
      this.data = data;
      this.activeTab = '1';
    },    
    handleCompletedForm(result) {
      if (!result) { return; }
      this.activeTab = '0';
      this.$nextTick(() => {
        this.data = undefined; 
        // this.$refs.list.loadData();
        this.$refs.list.loadDataBySearchWord();
      });
    },
    handleSelectAddress(addr) {
      this.activeTab = '2';
      this.addr = null;
      this.$nextTick(() => {
        this.addr = addr; 
      })
    },
    handleClosedForm(data){      
      this.data = data;
    }
  },
};
</script>
